import applePayFallback from '@/assets/images/transports-payments/apay.png?w=100'
import applePayAvif from '@/assets/images/transports-payments/apay.png?w=100&format=avif&as=srcset'
import applePayWebp from '@/assets/images/transports-payments/apay.png?w=100&format=webp&as=srcset'
import bgzBnpParibasFallback from '@/assets/images/transports-payments/bgz-bnp-paribas-sa.png?w=100'
import bgzBnpParibasAvif from '@/assets/images/transports-payments/bgz-bnp-paribas-sa.png?w=100&format=avif&as=srcset'
import bgzBnpParibasWebp from '@/assets/images/transports-payments/bgz-bnp-paribas-sa.png?w=100&format=webp&as=srcset'
import blikFallback from '@/assets/images/transports-payments/blik.png?w=100'
import blikAvif from '@/assets/images/transports-payments/blik.png?w=100&format=avif&as=srcset'
import blikWebp from '@/assets/images/transports-payments/blik.png?w=100&format=webp&as=srcset'
import bzwbkFallback from '@/assets/images/transports-payments/bzwbk.png?w=100'
import bzwbkAvif from '@/assets/images/transports-payments/bzwbk.png?w=100&format=avif&as=srcset'
import bzwbkWebp from '@/assets/images/transports-payments/bzwbk.png?w=100&format=webp&as=srcset'
import ceskaSporitelnaFallback from '@/assets/images/transports-payments/ceska-sporitelna.png?w=100'
import ceskaSporitelnaAvif from '@/assets/images/transports-payments/ceska-sporitelna.png?w=100&format=avif&as=srcset'
import ceskaSporitelnaWebp from '@/assets/images/transports-payments/ceska-sporitelna.png?w=100&format=webp&as=srcset'
import creditAgricoleFallback from '@/assets/images/transports-payments/credit-agricole.png?w=100'
import creditAgricoleAvif from '@/assets/images/transports-payments/credit-agricole.png?w=100&format=avif&as=srcset'
import creditAgricoleWebp from '@/assets/images/transports-payments/credit-agricole.png?w=100&format=webp&as=srcset'
import csobFallback from '@/assets/images/transports-payments/csob.png?w=100'
import csobAvif from '@/assets/images/transports-payments/csob.png?w=100&format=avif&as=srcset'
import csobWebp from '@/assets/images/transports-payments/csob.png?w=100&format=webp&as=srcset'
import dobirkaFallback from '@/assets/images/transports-payments/dobirka.png?w=100'
import dobirkaAvif from '@/assets/images/transports-payments/dobirka.png?w=100&format=avif&as=srcset'
import dobirkaWebp from '@/assets/images/transports-payments/dobirka.png?w=100&format=webp&as=srcset'
import edenredFallback from '@/assets/images/transports-payments/edenred.png?w=100'
import edenredAvif from '@/assets/images/transports-payments/edenred.png?w=100&format=avif&as=srcset'
import edenredWebp from '@/assets/images/transports-payments/edenred.png?w=100&format=webp&as=srcset'
import eplatbyFallback from '@/assets/images/transports-payments/eplatby.png?w=100'
import eplatbyAvif from '@/assets/images/transports-payments/eplatby.png?w=100&format=avif&as=srcset'
import eplatbyWebp from '@/assets/images/transports-payments/eplatby.png?w=100&format=webp&as=srcset'
import estravenkaFallback from '@/assets/images/transports-payments/estravenka.png?w=100'
import estravenkaAvif from '@/assets/images/transports-payments/estravenka.png?w=100&format=avif&as=srcset'
import estravenkaWebp from '@/assets/images/transports-payments/estravenka.png?w=100&format=webp&as=srcset'
import expressTransferCzFallback from '@/assets/images/transports-payments/expresni-prevod.png?w=500'
import expressTransferCzAvif from '@/assets/images/transports-payments/expresni-prevod.png?w=500&format=avif&as=srcset'
import expressTransferCzWebp from '@/assets/images/transports-payments/expresni-prevod.png?w=500&format=webp&as=srcset'
import expressTransferPlFallback from '@/assets/images/transports-payments/przelew-ekspresowy.png?w=500'
import expressTransferPlAvif from '@/assets/images/transports-payments/przelew-ekspresowy.png?w=500&format=avif&as=srcset'
import expressTransferPlWebp from '@/assets/images/transports-payments/przelew-ekspresowy.png?w=500&format=webp&as=srcset'
import fioBankaFallback from '@/assets/images/transports-payments/fio-banka.png?w=100'
import fioBankaAvif from '@/assets/images/transports-payments/fio-banka.png?w=100&format=avif&as=srcset'
import fioBankaWebp from '@/assets/images/transports-payments/fio-banka.png?w=100&format=webp&as=srcset'
import geMoneyBankFallback from '@/assets/images/transports-payments/ge-money-bank.png?w=100'
import geMoneyBankAvif from '@/assets/images/transports-payments/ge-money-bank.png?w=100&format=avif&as=srcset'
import geMoneyBankWebp from '@/assets/images/transports-payments/ge-money-bank.png?w=100&format=webp&as=srcset'
import gPayFallback from '@/assets/images/transports-payments/gpay.png?w=100'
import gPayAvif from '@/assets/images/transports-payments/gpay.png?w=100&format=avif&as=srcset'
import gPayWebp from '@/assets/images/transports-payments/gpay.png?w=100&format=webp&as=srcset'
import mojePlatbaFallback from '@/assets/images/transports-payments/mojeplatba.png?w=100'
import mojePlatbaAvif from '@/assets/images/transports-payments/mojeplatba.png?w=100&format=avif&as=srcset'
import mojePlatbaWebp from '@/assets/images/transports-payments/mojeplatba.png?w=100&format=webp&as=srcset'
import mTransferFallback from '@/assets/images/transports-payments/mtransfer.png?w=100'
import mTransferAvif from '@/assets/images/transports-payments/mtransfer.png?w=100&format=avif&as=srcset'
import mTransferWebp from '@/assets/images/transports-payments/mtransfer.png?w=100&format=webp&as=srcset'
import naseStravenkaFallback from '@/assets/images/transports-payments/nase-stravenka.png?w=100'
import naseStravenkaAvif from '@/assets/images/transports-payments/nase-stravenka.png?w=100&format=avif&as=srcset'
import naseStravenkaWebp from '@/assets/images/transports-payments/nase-stravenka.png?w=100&format=webp&as=srcset'
import pekao24PrzelewFallback from '@/assets/images/transports-payments/pekao24przelew.png?w=100'
import pekao24PrzelewAvif from '@/assets/images/transports-payments/pekao24przelew.png?w=100&format=avif&as=srcset'
import pekao24PrzelewWebp from '@/assets/images/transports-payments/pekao24przelew.png?w=100&format=webp&as=srcset'
import placAliorBankFallback from '@/assets/images/transports-payments/plac-z-alior-bank.png?w=100'
import placAliorBankAvif from '@/assets/images/transports-payments/plac-z-alior-bank.png?w=100&format=avif&as=srcset'
import placAliorBankWebp from '@/assets/images/transports-payments/plac-z-alior-bank.png?w=100&format=webp&as=srcset'
import placZBosFallback from '@/assets/images/transports-payments/plac-z-bos.png?w=100'
import placZBosAvif from '@/assets/images/transports-payments/plac-z-bos.png?w=100&format=avif&as=srcset'
import placZBosWebp from '@/assets/images/transports-payments/plac-z-bos.png?w=100&format=webp&as=srcset'
import placZCitiHandlowyFallback from '@/assets/images/transports-payments/plac-z-citi-handlowy.png?w=100'
import placZCitiHandlowyAvif from '@/assets/images/transports-payments/plac-z-citi-handlowy.png?w=100&format=avif&as=srcset'
import placZCitiHandlowyWebp from '@/assets/images/transports-payments/plac-z-citi-handlowy.png?w=100&format=webp&as=srcset'
import placZIngFallback from '@/assets/images/transports-payments/plac-z-ing.png?w=100'
import placZIngAvif from '@/assets/images/transports-payments/plac-z-ing.png?w=100&format=avif&as=srcset'
import placZIngWebp from '@/assets/images/transports-payments/plac-z-ing.png?w=100&format=webp&as=srcset'
import placZInteligoFallback from '@/assets/images/transports-payments/plac-z-inteligo.png?w=100'
import placZInteligoAvif from '@/assets/images/transports-payments/plac-z-inteligo.png?w=100&format=avif&as=srcset'
import placZInteligoWebp from '@/assets/images/transports-payments/plac-z-inteligo.png?w=100&format=webp&as=srcset'
import placZIpkoFallback from '@/assets/images/transports-payments/plac-z-ipko.png?w=100'
import placZIpkoAvif from '@/assets/images/transports-payments/plac-z-ipko.png?w=100&format=avif&as=srcset'
import placZIpkoWebp from '@/assets/images/transports-payments/plac-z-ipko.png?w=100&format=webp&as=srcset'
import placZMilleniumFallback from '@/assets/images/transports-payments/plac-z-millennium.png?w=100'
import placZMilleniumAvif from '@/assets/images/transports-payments/plac-z-millennium.png?w=100&format=avif&as=srcset'
import placZMilleniumWebp from '@/assets/images/transports-payments/plac-z-millennium.png?w=100&format=webp&as=srcset'
import placeZGetinFallback from '@/assets/images/transports-payments/place-z-getin.png?w=100'
import placeZGetinAvif from '@/assets/images/transports-payments/place-z-getin.png?w=100&format=avif&as=srcset'
import placeZGetinWebp from '@/assets/images/transports-payments/place-z-getin.png?w=100&format=webp&as=srcset'
import placeZNobleBankFallback from '@/assets/images/transports-payments/place-z-noble-bank.png?w=100'
import placeZNobleBankAvif from '@/assets/images/transports-payments/place-z-noble-bank.png?w=100&format=avif&as=srcset'
import placeZNobleBankWebp from '@/assets/images/transports-payments/place-z-noble-bank.png?w=100&format=webp&as=srcset'
import platebniKartaFallback from '@/assets/images/transports-payments/platebni-karta.png?w=100'
import platebniKartaAvif from '@/assets/images/transports-payments/platebni-karta.png?w=100&format=avif&as=srcset'
import platebniKartaWebp from '@/assets/images/transports-payments/platebni-karta.png?w=100&format=webp&as=srcset'
import plusBankFallback from '@/assets/images/transports-payments/plus-bank.png?w=100'
import plusBankAvif from '@/assets/images/transports-payments/plus-bank.png?w=100&format=avif&as=srcset'
import plusBankWebp from '@/assets/images/transports-payments/plus-bank.png?w=100&format=webp&as=srcset'
import prevodFallback from '@/assets/images/transports-payments/prevod.png?w=100'
import prevodAvif from '@/assets/images/transports-payments/prevod.png?w=100&format=avif&as=srcset'
import prevodWebp from '@/assets/images/transports-payments/prevod.png?w=100&format=webp&as=srcset'
import unicreditFallback from '@/assets/images/transports-payments/unicredit.png?w=100'
import unicreditAvif from '@/assets/images/transports-payments/unicredit.png?w=100&format=avif&as=srcset'
import unicreditWebp from '@/assets/images/transports-payments/unicredit.png?w=100&format=webp&as=srcset'
import prepaymentFallback from '@/assets/images/transports-payments/prepayment.png?w=100'
import prepaymentAvif from '@/assets/images/transports-payments/prepayment.png?w=100&format=avif&as=srcset'
import prepaymentWebp from '@/assets/images/transports-payments/prepayment.png?w=100&format=webp&as=srcset'
import paymentCreditsFallback from '@/assets/images/transports-payments/payment-credits.png?w=100'
import paymentCreditsAvif from '@/assets/images/transports-payments/payment-credits.png?w=100&format=avif&as=srcset'
import paymentCreditsWebp from '@/assets/images/transports-payments/payment-credits.png?w=100&format=webp&as=srcset'
import epsFallback from '@/assets/images/transports-payments/eps.png?w=100'
import epsAvif from '@/assets/images/transports-payments/eps.png?w=100&format=avif&as=srcset'
import epsWebp from '@/assets/images/transports-payments/eps.png?w=100&format=webp&as=srcset'
import qrPaymentFallback from '@/assets/images/transports-payments/qr-platba.png?w=100'
import qrPaymentAvif from '@/assets/images/transports-payments/qr-platba.png?w=100&format=avif&as=srcset'
import qrPaymentWebp from '@/assets/images/transports-payments/qr-platba.png?w=100&format=webp&as=srcset'

export const paymentsImages = [
  {
    name: 'transports-payments/dobirka.png',
    avif: dobirkaAvif,
    webp: dobirkaWebp,
    fallback: dobirkaFallback,
  },
  {
    name: 'transports-payments/utanvet.png',
    avif: dobirkaAvif,
    webp: dobirkaWebp,
    fallback: dobirkaFallback,
  },
  {
    name: 'transports-payments/platebni-karta.png',
    avif: platebniKartaAvif,
    webp: platebniKartaWebp,
    fallback: platebniKartaFallback,
  },
  {
    name: 'transports-payments/platobna-karta.png',
    avif: platebniKartaAvif,
    webp: platebniKartaWebp,
    fallback: platebniKartaFallback,
  },
  {
    name: 'transports-payments/carta-di-pagamento.png',
    avif: platebniKartaAvif,
    webp: platebniKartaWebp,
    fallback: platebniKartaFallback,
  },
  {
    name: 'transports-payments/plus-bank.png',
    avif: plusBankAvif,
    webp: plusBankWebp,
    fallback: plusBankFallback,
  },
  {
    name: 'transports-payments/karta-kredytowa.png',
    avif: platebniKartaAvif,
    webp: platebniKartaWebp,
    fallback: platebniKartaFallback,
  },
  {
    name: 'transports-payments/bankkartya.png',
    avif: platebniKartaAvif,
    webp: platebniKartaWebp,
    fallback: platebniKartaFallback,
  },

  {
    name: 'transports-payments/za-pobraniem.png',
    avif: dobirkaAvif,
    webp: dobirkaWebp,
    fallback: dobirkaFallback,
  },
  {
    name: 'transports-payments/edenred.png',
    avif: edenredAvif,
    webp: edenredWebp,
    fallback: edenredFallback,
  },
  {
    name: 'transports-payments/nase-stravenka.png',
    avif: naseStravenkaAvif,
    webp: naseStravenkaWebp,
    fallback: naseStravenkaFallback,
  },
  {
    name: 'transports-payments/apay.png',
    avif: applePayAvif,
    webp: applePayWebp,
    fallback: applePayFallback,
  },
  {
    name: 'transports-payments/gpay.png',
    avif: gPayAvif,
    webp: gPayWebp,
    fallback: gPayFallback,
  },
  {
    name: 'transports-payments/prevod.png',
    avif: prevodAvif,
    webp: prevodWebp,
    fallback: prevodFallback,
  },
  {
    name: 'transports-payments/atutalas.png',
    avif: prevodAvif,
    webp: prevodWebp,
    fallback: prevodFallback,
  },
  {
    name: 'transports-payments/przelew.png',
    avif: prevodAvif,
    webp: prevodWebp,
    fallback: prevodFallback,
  },
  {
    name: 'transports-payments/expresni-prevod.png',
    avif: expressTransferCzAvif,
    webp: expressTransferCzWebp,
    fallback: expressTransferCzFallback,
  },
  {
    name: 'transports-payments/przelew-ekspresowy.png',
    avif: expressTransferPlAvif,
    webp: expressTransferPlWebp,
    fallback: expressTransferPlFallback,
  },
  {
    name: 'transports-payments/dobierka.png',
    avif: dobirkaAvif,
    webp: dobirkaWebp,
    fallback: dobirkaFallback,
  },
  {
    name: 'transports-payments/csob.png',
    avif: csobAvif,
    webp: csobWebp,
    fallback: csobFallback,
  },
  {
    name: 'transports-payments/ceska-sporitelna.png',
    avif: ceskaSporitelnaAvif,
    webp: ceskaSporitelnaWebp,
    fallback: ceskaSporitelnaFallback,
  },
  {
    name: 'transports-payments/mojeplatba.png',
    avif: mojePlatbaAvif,
    webp: mojePlatbaWebp,
    fallback: mojePlatbaFallback,
  },
  {
    name: 'transports-payments/fio-banka.png',
    avif: fioBankaAvif,
    webp: fioBankaWebp,
    fallback: fioBankaFallback,
  },
  {
    name: 'transports-payments/ge-money-bank.png',
    avif: geMoneyBankAvif,
    webp: geMoneyBankWebp,
    fallback: geMoneyBankFallback,
  },
  {
    name: 'transports-payments/eplatby.png',
    avif: eplatbyAvif,
    webp: eplatbyWebp,
    fallback: eplatbyFallback,
  },
  {
    name: 'transports-payments/estravenka.png',
    avif: estravenkaAvif,
    webp: estravenkaWebp,
    fallback: estravenkaFallback,
  },
  {
    name: 'transports-payments/unicredit.png',
    avif: unicreditAvif,
    webp: unicreditWebp,
    fallback: unicreditFallback,
  },
  {
    name: 'transports-payments/plac-z-alior-bank.png',
    avif: placAliorBankAvif,
    webp: placAliorBankWebp,
    fallback: placAliorBankFallback,
  },
  {
    name: 'transports-payments/blik.png',
    avif: blikAvif,
    webp: blikWebp,
    fallback: blikFallback,
  },
  {
    name: 'transports-payments/bgz-bnp-paribas-sa.png',
    avif: bgzBnpParibasAvif,
    webp: bgzBnpParibasWebp,
    fallback: bgzBnpParibasFallback,
  },
  {
    name: 'transports-payments/plac-z-bos.png',
    avif: placZBosAvif,
    webp: placZBosWebp,
    fallback: placZBosFallback,
  },
  {
    name: 'transports-payments/plac-z-ing.png',
    avif: placZIngAvif,
    webp: placZIngWebp,
    fallback: placZIngFallback,
  },
  {
    name: 'transports-payments/place-z-getin.png',
    avif: placeZGetinAvif,
    webp: placeZGetinWebp,
    fallback: placeZGetinFallback,
  },
  {
    name: 'transports-payments/plac-z-inteligo.png',
    avif: placZInteligoAvif,
    webp: placZInteligoWebp,
    fallback: placZInteligoFallback,
  },
  {
    name: 'transports-payments/credit-agricole.png',
    avif: creditAgricoleAvif,
    webp: creditAgricoleWebp,
    fallback: creditAgricoleFallback,
  },
  {
    name: 'transports-payments/mtransfer.png',
    avif: mTransferAvif,
    webp: mTransferWebp,
    fallback: mTransferFallback,
  },
  {
    name: 'transports-payments/place-z-noble-bank.png',
    avif: placeZNobleBankAvif,
    webp: placeZNobleBankWebp,
    fallback: placeZNobleBankFallback,
  },
  {
    name: 'transports-payments/pekao24przelew.png',
    avif: pekao24PrzelewAvif,
    webp: pekao24PrzelewWebp,
    fallback: pekao24PrzelewFallback,
  },
  {
    name: 'transports-payments/plac-z-ipko.png',
    avif: placZIpkoAvif,
    webp: placZIpkoWebp,
    fallback: placZIpkoFallback,
  },
  {
    name: 'transports-payments/bzwbk.png',
    avif: bzwbkAvif,
    webp: bzwbkWebp,
    fallback: bzwbkFallback,
  },
  {
    name: 'transports-payments/plac-z-citi-handlowy.png',
    avif: placZCitiHandlowyAvif,
    webp: placZCitiHandlowyWebp,
    fallback: placZCitiHandlowyFallback,
  },
  {
    name: 'transports-payments/plac-z-millennium.png',
    avif: placZMilleniumAvif,
    webp: placZMilleniumWebp,
    fallback: placZMilleniumFallback,
  },
  {
    name: 'transports-payments/platba-predem.png',
    avif: prepaymentAvif,
    webp: prepaymentWebp,
    fallback: prepaymentFallback,
  },
  {
    name: 'transports-payments/platnosc-z-gory-2.png',
    avif: prepaymentAvif,
    webp: prepaymentWebp,
    fallback: prepaymentFallback,
  },
  {
    name: 'transports-payments/fizetes-ajandekutalvannyal.png',
    avif: prepaymentAvif,
    webp: prepaymentWebp,
    fallback: prepaymentFallback,
  },
  {
    name: 'transports-payments/uhrada-kredity.png',
    avif: paymentCreditsAvif,
    webp: paymentCreditsWebp,
    fallback: paymentCreditsFallback,
  },
  {
    name: 'transports-payments/platnosc-punktami.png',
    avif: paymentCreditsAvif,
    webp: paymentCreditsWebp,
    fallback: paymentCreditsFallback,
  },
  {
    name: 'transports-payments/fizetes-kreditpontokkal.png',
    avif: paymentCreditsAvif,
    webp: paymentCreditsWebp,
    fallback: paymentCreditsFallback,
  },
  {
    name: 'transports-payments/paga-con-crediti.png',
    avif: paymentCreditsAvif,
    webp: paymentCreditsWebp,
    fallback: paymentCreditsFallback,
  },
  {
    name: 'transports-payments/eps.png',
    avif: epsAvif,
    webp: epsWebp,
    fallback: epsFallback,
  },
  {
    name: 'transports-payments/qr-platba.png',
    avif: qrPaymentAvif,
    webp: qrPaymentWebp,
    fallback: qrPaymentFallback,
  },
]
